import { Suspense } from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/auth-contex";
import { LoadingContainer } from "./styles";
import permissionsStore from "../../store/permissions";
import { NavTab } from "../navigation";

export const ProtectedMasterRoutes = () => {
  const { user, loading } = useAuthContext();
  const { role } = permissionsStore();

  const LoadingComp = () => {
    return (
      <LoadingContainer>
        <div className="loading">
          <h1 className="lbl">Carregando...</h1>
        </div>
      </LoadingContainer>
    );
  };
  {
    /**master */
  }
  if (user && role === "master") {
    return (
      <Suspense fallback={<LoadingComp />}>
        <NavTab />
      </Suspense>
    );
  }

  if (loading) {
    return <LoadingComp />;
  }
  return <Navigate to="/login" />;
};
